import { Mood } from '@prisma/client'
import { useRef, useEffect } from 'react'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

import { supabaseClient } from 'supabaseClient'
import { useProvider } from 'hooks/useMoodPlot'

export default function ExistingMoodsFetcher({ groupId }: { groupId: string }) {
  const mounted = useRef(false)
  const { setExistingMoods, setPlottedMoods } = useProvider()

  // Check if this session has been already recorded for this group
  useEffect(() => {
    if (mounted.current) return
    async function check() {
      const agent = await FingerprintJS.load()
      const fingerprint = await agent.get()

      const { data: myMoods } = await supabaseClient
        .from<Mood>('moods')
        .select('id')
        .eq('group_id', groupId)
        .eq('session_id', fingerprint.visitorId)

      if (myMoods) {
        setPlottedMoods(myMoods.map(({ id }) => id))
        setExistingMoods(myMoods.length)
      }
      mounted.current = true
    }
    check()
  }, [groupId, setExistingMoods, setPlottedMoods])

  return null
}
